// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__MKQjc","modalForm":"UpgradeEpcsModal_modalForm__1ijZg","modalFooter":"UpgradeEpcsModal_modalFooter__Rczrf"};